import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './unsaved-changes.component.html'
})
export class UnsavedChangesComponent implements OnInit {
  constructor(
    private readonly activeModal: DynamicDialogRef
  ) {
  }

  ngOnInit(): void {
  }

  onOk() {
    this.activeModal.close(true);
  }

  onCancel() {
    this.activeModal.close(false);
  }
}
